import request from '@/utils/request'

// 搜索用户列表
export function searchUserList(params) {
  return request({
    url: '/users',
    method: 'get',
    params: params
  })
}

/** 订单经办人下拉（需 orders查看权限，教务可用） */
export function getOrderHandlers() {
  return request({
    url: '/users/order-handlers',
    method: 'get'
  })
}

export function getUsers() {
  return request({
    url: '/users',
    method: 'get'
  })
}

export function getUserPreferences() {
  return request({
    url: '/users/me/preferences',
    method: 'get'
  })
}

export function updateUserPreferences(data) {
  return request({
    url: '/users/me/preferences',
    method: 'patch',
    data
  })
}
